import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default () => ({
  path: ":nodeId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "ScopeAndSequenceWrapper" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
